"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = maxTranslate;
function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJtYXhUcmFuc2xhdGUiLCJzbmFwR3JpZCIsImxlbmd0aCJdLCJzb3VyY2VzIjpbIm1heFRyYW5zbGF0ZS5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBtYXhUcmFuc2xhdGUoKSB7XG4gIHJldHVybiAtdGhpcy5zbmFwR3JpZFt0aGlzLnNuYXBHcmlkLmxlbmd0aCAtIDFdO1xufSJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQWUsU0FBU0EsWUFBWUEsQ0FBQSxFQUFHO0VBQ3JDLE9BQU8sQ0FBQyxJQUFJLENBQUNDLFFBQVEsQ0FBQyxJQUFJLENBQUNBLFFBQVEsQ0FBQ0MsTUFBTSxHQUFHLENBQUMsQ0FBQztBQUNqRCJ9